// Public plans feed (GET /plans). Shared by the landing pricing section
// and the /pricing page so both render the same live data.

import { useEffect, useState } from "react";

import { api } from "@/lib/api";

export type BillingPeriod = "monthly" | "annual";

interface PriceCell {
  cents: number;
  display: string;
}

export interface PlanRow {
  slug: string;
  name: string;
  description: string;
  features: Record<string, boolean>;
  max_engagements: number;
  max_scans_per_month: number;
  max_users: number;
  price_cents: number;
  price_display: string;
  currency: string;
  // { [currency]: { monthly, annual } } — annual is monthly × 10
  // (2 months free), derived server-side in services/pricing.py.
  prices: Record<string, Record<BillingPeriod, PriceCell>>;
  billing_cycle: string;
  display_order: number;
}

export function usePlans(): PlanRow[] {
  const [plans, setPlans] = useState<PlanRow[]>([]);
  useEffect(() => {
    api<PlanRow[]>("/plans")
      .then(setPlans)
      .catch(() => setPlans([]));
  }, []);
  return plans;
}
